<template>
  <div>
    <v-app-bar
      v-if="adminUser"
      app
      color="white"
    >
      <v-app-bar-nav-icon
        @mouseenter="drawer = true"
        @click="drawer = !drawer"
      />

      <v-toolbar-title>
        <v-img
          max-height="180"
          max-width="180"
          contain
          :src="require(`@/assets/images/DXEstation_logo_RGB.png`)"
        />
      </v-toolbar-title>

      <v-spacer />
    </v-app-bar>
    <v-navigation-drawer
      v-if="adminUser"
      v-model="drawer"
      fixed
      dark
      temporary
      color="primary"
      width="320"
      :style="drawerStyle"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <strong>DXE Station Admin</strong>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-spacer />

      <v-list
        shaped
        expand
      >
        <v-list-item-group
          v-model="selectedMenu"
          mandatory
        >
          <template v-for="nav_list in items">
            <v-list-item
              v-if="!nav_list.items"
              :key="nav_list.key"
              @click="listClickEvent(nav_list)"
            >
              <v-list-item-icon>
                <v-icon>{{ nav_list.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nav_list.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-else
              :key="nav_list.key"
              :value="nav_list.opened"
              no-action
              :prepend-icon="nav_list.icon"
              color="white"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ nav_list.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="list in nav_list.items"
                :key="list.key"
                active-class="sideMenuSelected"
                link
                @click="listClickEvent(list)"
              >
                <v-list-item-title>
                  {{ list.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-item-group>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn
            block
            @click="logoutButtonClickEvent"
          >
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'HeaderNav',
  components: {
  },
  mixins: [
  ],
  data () {
    return {
      selectedMenu: '1_1',
      showNavIcon: false,
      drawer: false,
      items: [
        { title: '契約者', icon: 'mdi-office-building', name: 'AdminContractors', key: '1-1', params: { resetCondition: true, resetPagination: true } },
        { title: 'EDI申込管理', icon: 'mdi-file-document-outline', name: 'AdminEdiRequests', key: '1-2', params: { resetCondition: true, resetPagination: true } },
        { title: 'テナントへのお知らせ', icon: 'mdi-bell-outline', name: 'AdminNotifications', key: '1-3', params: { resetCondition: true, resetPagination: true } },
        { title: 'トピック表示', icon: 'mdi-newspaper-variant-outline', name: 'AdminTopics', key: '1-4', params: { resetCondition: true, resetPagination: true } },
        { title: 'DXEへのお知らせ', icon: 'mdi-information-outline', name: 'AdminDxeNotifications', key: '1-5', params: { resetCondition: true, resetPagination: true } },
        { title: 'Adminユーザ', icon: 'mdi-account-multiple', name: 'AdminUsers', key: '1-6', params: { resetCondition: true, resetPagination: true } },
        { title: 'テナントユーザ', icon: 'mdi-account-multiple', name: 'AdminTenantUsers', key: '1-7', params: { resetCondition: true, resetPagination: true } },
        {
          title: 'DXEマスタ',
          icon: 'mdi-clipboard-file-outline',
          key: '2-0',
          sub_menu_keys: '/admin/masters',
          opened: false,
          items: [
            { title: '排出事業者', name: 'AdminMasterEmissions', key: '2-1', params: { resetCondition: true, resetPagination: true } },
            { title: '収集運搬業者', name: 'AdminMasterTransports', key: '2-2', params: { resetCondition: true, resetPagination: true } },
            { title: '処分業者', name: 'AdminMasterDisposers', key: '2-3', params: { resetCondition: true, resetPagination: true } },
            { title: '政令市', name: 'AdminMasterOrdinanceCities', key: '2-4', params: { resetCondition: true, resetPagination: true } },
          ]
        },
        {
          title: '利用規約',
          icon: 'mdi-cog',
          key: '3-0',
          sub_menu_keys: '/admin/systems',
          opened: false,
          items: [
            { title: '排出利用規約', name: 'AdminSystemShow', key: '3-1', params: { type: 'emission', resetCondition: true, resetPagination: true } },
            { title: 'EDI申請利用規約', name: 'AdminSystemShow', key: '3-2', params: { type: 'edi_request', resetCondition: true, resetPagination: true } },
          ]
        },
        { title: '請求データ', icon: 'mdi-note-text-outline', name: 'AdminInvoices', key: '4-1', params: { resetCondition: true, resetPagination: true } },
        { title: 'マニフェスト登録件数', icon: 'mdi-list-status', name: 'AdminManifestReports', key: '5-1', params: { resetCondition: true, resetPagination: true } },
        {
          title: 'マニ自動化',
          icon: 'mdi-pipe-disconnected',
          key: '9-0',
          sub_menu_keys: '/admin/edi_settings',
          opened: false,
          items: [
            { title: '管理', name: 'AdminEdiSettingsManagements', key: '9-1' },
          ]
        },
        {
          title: '電子契約',
          icon: 'mdi-file-sign',
          key: '10-0',
          sub_menu_keys: '/admin/contracts',
          opened: false,
          items: [
            { title: '認印送信件数', name: 'AdminContractsSummaries', key: '10-1' },
          ]
        },
        {
          title: '停止スケジュール',
          icon: 'mdi-clock-alert-outline',
          key: '11-0',
          sub_menu_keys: '/admin/schedules',
          opened: false,
          items: [
            { title: 'JWNET', name: 'AdminSchedulesJwnetMaintenances', key: '11-1' },
            { title: '電子契約', name: 'AdminSchedulesWansignMaintenances', key: '11-2' },
            { title: 'データベース', name: 'AdminSchedulesDbMaintenances', key: '11-3' },
          ]
        },
      ],
    }
  },
  computed: {
    ...mapGetters('AdminAuthentication', [
      'adminUser'
    ]),
    /**
     * ヘッダーの高さに応じてメニューの位置を調整
     */
    drawerStyle() {
      // モバイル (xs, sm) では 56px、それ以外は 64px
      const headerHeight = this.$vuetify.breakpoint.smAndDown ? 56 : 64
      return {
        top: `${headerHeight}px !important`,
        height: `calc(100% - ${headerHeight}px) !important`
      }
    }
  },
  watch: {
    $route(to, from) {
      this.openMenu()
    },
  },
  created() {
    this.openMenu()
  },
  methods: {
    ...mapActions('AdminAuthentication', {
      signOut: 'signOutAdmin'
    }),
    /**
     * サブメニュー選択時の表示制御
     */
    openMenu() {
      let routePath = this.$route.path;
      for (const menu of this.items) {
        // サブメニューあり
        if (menu.items) {
          const submenuKeys = menu.sub_menu_keys.split(',')
          let exists = submenuKeys.find((v) => routePath.includes(v))

          // 一致
          if (exists) {
            menu.opened = true
          }
        }
      }
    },
    listClickEvent (item) {
      this.$router.push({ name: item.name, params: item.params }, () =>{})
    },
    logoutButtonClickEvent () {
      this.signOut().then(() => {
        this.drawer = false
        this.$router.replace({ name: 'AdminSession' }, () => {})
      })
    },
  }
}

</script>
